import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AppVariant } from './app-variant';
import { useKompis } from './contexts';
import { useCountryCode, useIsKiosk, usePresetStoreId } from './contexts/environment';
import { useCookieSubscription } from './hooks/useCookieSubscription';
import { initializeAppTranslations, initializePlanner, initializeProducts } from './store/initialize';
import { getProductsFetched } from './store/products/selectors';
import LoadingIndicator from './views/LoadingIndicator';
/**
 *
 * @returns The application.
 */
const App = ({ planner, insightsApi, ab }) => {
    const countryCode = useCountryCode();
    const isKiosk = useIsKiosk();
    const presetStoreId = usePresetStoreId();
    const [stateLoaded, setStateLoaded] = useState(false);
    const { translations, productService } = useKompis();
    const productsFetched = useSelector(getProductsFetched);
    useCookieSubscription();
    useEffect(() => {
        initializePlanner(planner, insightsApi, countryCode, isKiosk, presetStoreId, ab);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [planner, countryCode, isKiosk, presetStoreId]);
    useEffect(() => {
        initializeAppTranslations(translations);
    }, [translations]);
    useEffect(() => {
        if (!productsFetched) {
            initializeProducts(productService);
        }
    }, [productsFetched, productService]);
    useEffect(() => {
        productsFetched && setStateLoaded(true);
    }, [productsFetched]);
    return stateLoaded ? _jsx(AppVariant, {}) : _jsx(LoadingIndicator, {});
};
export default App;
//# sourceMappingURL=App.js.map